import $ from 'jquery';
import AOS from 'aos';
import 'jquery-parallax.js';

import { TextDisplayFirstLetter } from './components/test-display-first-letter';
import { Slider } from './components/slider';
import { MobileNav } from './components/mobile-nav';
import { HomeHeader } from './components/home-header';
import { ContactForm } from './components/contact-form';
import { ProjectListingLoadMore } from './components/project-listing-load-more';

const components = [
    Slider,
    TextDisplayFirstLetter,
    MobileNav,
    HomeHeader,
    ContactForm,
    ProjectListingLoadMore,
];

document.addEventListener('DOMContentLoaded', () => {
    components.forEach(Component => Component.create());

    AOS.init({
        duration: 600,
    });

    /* Open all truly external links in new tab */
    $('a[href^="http://"], a[href^="https://"]').on('click', function () {
        const currentHostname = window.location.hostname;
        const destHostname = this.hostname;
        if (currentHostname !== destHostname) {
            $(this).attr('target', '_blank');
        }
    });
});



// WEBPACK FOOTER //
// ./assets/js/main.js